import { apiRequest } from '@/lib/api/client'

import { buildCancelShipmentsBody } from './cancel'
import { cancelShipmentsResponseSchema } from './schema'

const SHIPMENT_METADATA = btoa(
  JSON.stringify({
    app_version: '1.0.0',
    device_id: 'jastiper-web',
    device_name: 'Jastiper Web',
    timezone: 'Asia/Jakarta',
  }),
)

/** POST /v4/shipment/me/cancel — same contract as Customer App (WEBLP-2507). */
export function cancelShipments(shipmentIds: readonly string[], signal?: AbortSignal) {
  return apiRequest('/v4/shipment/me/cancel', {
    method: 'POST',
    schema: cancelShipmentsResponseSchema,
    body: buildCancelShipmentsBody(shipmentIds),
    headers: { Metadata: SHIPMENT_METADATA },
    signal,
  })
}
